import { ElLoading } from "element-plus";
export function startLoading() {
  return ElLoading.service({
    lock: true,
    text: "Loading",
    background: "rgba(0, 0, 0, 0.7)",
  });
}
